// extracted by mini-css-extract-plugin
export var link = "Social-module--link--dwgkh";
export var root = "Social-module--root--5HYkI";